import React, { Component } from "react";
import { style } from "typestyle";
import Button from "../components/Button";
import Circle from "./Circle";
import Success from "./Success";

type Props = {
  disabled: boolean;
  isAccurate: boolean;
  onChange: (isAccurate: boolean) => void;
};
export default class AccurateControl extends Component<Props> {
  state = {
    isOpen: false,
  };

  render(): JSX.Element | null {
    const { disabled } = this.props;
    return disabled
      ? null
      : this.props.isAccurate
      ? this.renderDrawButton(
          "Accurate Scan Area",
          <Success />,
          "Boundaries are accurate, GCP network will be suggested based on them",
          () => {
            this.props.onChange(false);
          },
          true,
        )
      : this.renderDrawButton(
          "Mark as Accurate",
          <Circle />,
          "Check if the boundaries are accurate and a GCP network should be suggested",
          () => {
            this.props.onChange(true);
          },
          false,
        );
  }

  onMouseEnter = (): void => {
    this.setState({ isOpen: true });
  };

  onMouseLeave = (): void => {
    this.setState({ isOpen: false });
  };

  renderDrawButton(
    label: string,
    icon: JSX.Element,
    tooltipTitle: string,
    onclick: () => void,
    colorInvert: boolean,
  ): JSX.Element {
    return this.state.isOpen ? (
      <div
        className={style({
          display: "inline-block",
          position: "absolute",
        })}
      >
        <Button
          type={"control"}
          onClick={onclick}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          icon={icon}
          label={label}
        />

        <div
          className={style({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          })}
        >
          <div
            className={style({
              background: colorInvert ? "#FFFFFF" : "rgba(0, 0, 0, 0.65)",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.35)",
              boxSizing: "border-box",
              position: "relative",
              width: "172px",
              margin: "4px 0",
              fontSize: "12px",
              lineHeight: "14px",
              backdropFilter: "blur(20px)",
              color: colorInvert ? "#000" : "#FFFFFF",
              letterSpacing: "-0.25px",
              padding: "8px 12px 8px 12px",
            })}
          >
            {tooltipTitle}
          </div>
        </div>
      </div>
    ) : (
      <div
        className={style({
          display: "inline-block",
          position: "absolute",
        })}
      >
        <Button
          type={"control"}
          onClick={onclick}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          icon={icon}
          label={label}
        />
      </div>
    );
  }
}
